import React, { useState } from 'react';
import UpdateFooter from './UpdateFooter';
import StarRating from './StarRating';
import FooterNavigation from './FooterNavigation';
import { helpers } from '../services/helpers';

function UpdateCard({
    update,
    setCurrentUpdateIndex,
    currentUpdateIndex,
    updatesLength,
    isEditable,
    toast,
    loadReviews,
    review,
}) {
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    const minSwipeDistance = 50;

    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            setCurrentUpdateIndex(prev => Math.min(updatesLength - 1, prev + 1));
        } else if (isRightSwipe) {
            setCurrentUpdateIndex(prev => Math.max(0, prev - 1));
        }
    };
    return (
        <div
            className="update-card"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >

            <div style={{ padding: '0 0.5rem' }}>
                <div className="update-header">
                    <span className="post-op-timestamp">
                        {helpers.postopTimestampAt(review.surgeryDate, update.createdAt)}
                    </span>
                    <div>{Boolean(update.rating) && (
                        <StarRating className="star-rating" rating={update.rating} />
                    )}
                    </div>
                </div>
                <p className="update-text">{update.description}</p>
                <FooterNavigation
                    leftClick={() => setCurrentUpdateIndex(prev => Math.max(0, prev - 1))}
                    rightClick={() => setCurrentUpdateIndex(prev => Math.min(updatesLength - 1, prev + 1))}
                    currentIndex={currentUpdateIndex}
                    length={updatesLength}
                    assetType="Update"
                />
            </div>
            {isEditable && (
                <UpdateFooter
                    update={update}
                    loadReviews={loadReviews}
                    toast={toast}
                />
            )}
        </div>
    )
}

export default UpdateCard;